import { NgModule } from '@angular/core';
import { LibBackIconComponent } from './lib-back-icon.component';

@NgModule({
  declarations: [LibBackIconComponent],
  imports: [],
  exports: [LibBackIconComponent],
})
export class LibBackIconModule {}
